import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {emAddCommasToNumber} from 'utilities/extensionMethods'
import CustomIconPagination from './CustomIconPagination'

interface Props {
  results: any
  loading: boolean
  itemsPP: number
  page: number
  handlePagination: (e: React.ChangeEvent<unknown>, v: number) => void
  totalCount: number
  prev?: boolean
  next?: boolean
}
export default function PaginationHeader({
  prev,
  next,
  results,
  loading,
  itemsPP,
  page,
  handlePagination,
  totalCount,
}: Props) {
  return (
    <>
      {results && (results?.length ?? 0 > 0) && !loading && (prev || next) ? (
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          bgcolor={'#f7f9fb'}
          sx={{
            p: 0.5,
            mb: 0.5,
            pl: 2,
            pr: 2,
            textShadow: '1px 1px 1px white, 0 0 1px grey, 0 0 0.1em grey',
          }}
          boxShadow={'rgba(0, 0, 0, 0.04) 0px 3px 5px'}
        >
          <Typography variant={'body1'}>{`Showing ${
            results.length
          } Results for page: ${page} of ${emAddCommasToNumber(
            Math.ceil(totalCount / itemsPP)
          )} `}</Typography>
          <Typography variant={'body1'}>{`Total Results: ${emAddCommasToNumber(
            totalCount
          )}`}</Typography>
          <CustomIconPagination
            page={page}
            onChange={handlePagination}
            hideNextButton={Math.floor(totalCount / itemsPP) === page}
            numberOfResults={totalCount}
            itemsPP={itemsPP}
          />
        </Box>
      ) : (
        <></>
      )}
    </>
  )
}
